(() => {
  if (window.mgpHaleyVariantGalleryInstalled) return;
  window.mgpHaleyVariantGalleryInstalled = true;
  const maps = new WeakMap();
  document.addEventListener("variant:change", event => {
    const variant = event.detail && event.detail.variant;
    const root = event.target.closest && event.target.closest('[data-mgp-variant-media]');
    if (!root || !variant) return;
    let map = maps.get(root);
    if (!map) {
      try { map = JSON.parse(root.getAttribute("data-mgp-variant-media")); }
      catch (_) { return; }
      maps.set(root, map);
    }
    const ids = map && map[String(variant.id)];
    if (!Array.isArray(ids) || !ids.length) return;
    const allowed = new Set(ids.map(String));
    const color = String(variant.option1 || "").toLowerCase();
    root.querySelectorAll(".product-gallery__carousel-item, .product-gallery__thumbnail").forEach(cell => {
      cell.setAttribute("data-group-value", allowed.has(cell.getAttribute("data-media-id")) ? color : "__mgp_other_configuration__");
    });
  }, true);
})();
